module.exports = __webpack_public_path__ + "static/media/icon-store.7e39c0b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/featured-cards/icons/icon-store.png
// module id = 2229
// module chunks = 0